import styled from 'styled-components';

const StyledHomeHeroDark = styled.div`
position: relative;
top: 0;
height: auto;
background-color: #000;
.hero-dark--wrap{
  position: relative;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}
.hero-dark--slider {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transform: translateX(${props => props.indexCurrent * - 100}%);
  transition: transform 0.75s ease-out;
}
.hero--video-wrap{
  position: fixed;
  top: 0;
  left: -100%;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.hero--video-loop{
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  padding-right: 64px;
  padding-left: 64px;
  flex: 0 0 100%;
}
.bullets--wrap {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
  display: flex;
  align-items: center;
  .bullet {
    width: 10px;
    height: 10px;
    border: 1px solid #fff;
    margin: 0 10px;
    border-radius: 50%;
    cursor: pointer;
    &.selected {
      background-color: #fff;
    }
  }
}
.loop-wrap{
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.loop-wrap .opacity-layer{
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.4);
}
.hero--video-loop video{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  overflow: hidden;
  display: block;
  min-width: 100%; 
  min-height: 100%; 
  width: 100%; 
  height: auto; 
  background-size: cover;
  object-fit: cover;
  z-index: 1;
}
.text-wrap-cta{
  position: relative;
  width: 50%;
  text-align: left;
  color: #fff;
  z-index: 2;
  
}
.text-wrap-cta h4 {
  opacity: 0;
  filter: blur(10px);
  transition: opacity 0.5s ease-out 0.5s, filter 0.75s ease-out 0.5s;
}
.row-shelfzone {
  opacity: 0;
  filter: blur(10px);
  transition: opacity 0.5s ease-out 0.5s, filter 0.75s ease-out 0.5s;
  img {
    display: block;
    width: 132px;
    margin-bottom: 10px;
  }
}
.selected .text-wrap-cta h4{ 
  opacity: 1;
  filter: blur(0);
}
.selected .row-shelfzone {
  opacity: 1;
  filter: blur(0);
}
.rounded--cta{
  color: #fff;
  display: inline-block;
  margin-top: 48px;
  border-color: #fff;
  opacity: 0;
  transition: opacity 0.5s ease-out 0.75s, background-color 0.5s ease-out 0s, color 0.5s ease-out 0s;
}
.selected .rounded--cta { 
  opacity: 1;
  transition: opacity 0.5s ease-out 0.85s, background-color 0.5s ease-out 0s, color 0.5s ease-out 0s;
}
.rounded--cta:hover{
  background-color: #fff;
  color: #000;
  border-color: #fff;
  @media screen and (max-width: 1023px){ 
    color: #fff;
    background-color: transparent;
  }
}
.video-holder{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}
.video-holder .poster{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background-size: cover;
  z-index: 4;
  opacity: 1;
  transition: opacity 0.25s;
  pointer-events: none;
}
.video-holder .poster.played {
  opacity: 0;
}
.hero--video-wrap video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  overflow: hidden;
  display: block;
  min-width: 100%; 
  min-height: 100%; 
  width: 100%; 
  height: auto; 
  background-size: cover;
  object-fit: cover;
}
.hero-dark-text--wrap{
  position: relative;
  width: 41.65%;
  margin-left: 8.33%;
  color: #fff;
  padding-top: ${props => props.theme.components_spacing_desk.medium}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  padding-left: 64px;
  padding-right: 64px;
}
.close-video{
  position: absolute;
  z-index: 11;
  right: 64px;
  top: 40px;
}
.close-video img{
  display: block;
  width: 44px;
}
h1{
  padding-bottom: ${props => props.theme.components_spacing_desk.regular}px;
}

.play{
  position: absolute;
  z-index: 4;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
}
.play-icon{
  position: relative;
  z-index: 2;
  margin: 0 auto;
  opacity: 0;
  transform: rotate(-45deg);
  width: 72px;
  height: 72px;
  opacity: 0
}
.circle--bg{
  position: absolute;
  z-index: 1;
  opacity: 0;
  width: 96px;
  height: 96px;
  transform: scale(0.35);
  border-radius: 50%;
  background-color: rgba(255,255,255,0.3);
  opacity: 0;
}

.toggle-audio{
  position: absolute;
  bottom: 48px;
  right: 64px;
  width: 56px;
  height: 56px;
  z-index: 4;
  border-radius: 50%;
  background-color: #000;
  cursor: pointer;
}
.toggle-audio:after{
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 24px;
  transform: translate(-50%, -50%);
  background-image: url("./volume-off-desk.svg");
  background-size: 24px;

}
.toggle-audio.mute:after{
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 24px;
  transform: translate(-50%, -50%);
  background-image: url("./volume-on-desk.svg");
  background-size: 24px;

}
.small-play{
  position: absolute;
  bottom: 48px;
  right: 134px;
  width: 56px;
  height: 56px;
  z-index: 4;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.small-play .pause-bar{
  background-color: #fff;
  width: 6px;
  height: 20px;
  border-radius: 2px;
  margin: 0 2px;
  transform: translateY(56px);
}

@media screen and (max-width: 1439px){
  .hero--video-loop{
    padding-right: 40px;
    padding-left: 40px;
  }
}
@media screen and (max-width: 1023px){

  .play-icon{
    width: 56px;
    height: 56px;
  }
  .circle--bg {
    width: 78px;
    height: 78px;
  }
  .toggle-audio{
    bottom: 24px;
    right: 40px;
    width: 32px;
    height: 32px;
  }
  .toggle-audio:after{
    width: 16px;
    height: 16px;
    background-size: 16px;
    background-image: url("./volume-off-mobile.svg");
  }
  .toggle-audio.mute:after{
    width: 16px;
    height: 16px;
    background-size: 16px;
    background-image: url("./volume-on-mobile.svg");
  }
  .small-play{
    position: absolute;
    bottom: 24px;
    right: 74px;
    width: 32px;
    height: 32px;
    z-index: 4;
    cursor: pointer;
  }
  .small-play .pause-bar{
    background-color: #fff;
    width: 4px;
    height: 13px;
    border-radius: 2px;
    margin: 0 1px;
    transform: translateY(32px);
  }
}
@media screen and (max-width: 1023px){
  .toggle-audio{
    right: 24px;
  }
}
@media screen and (max-width: 1439px){
  .hero-dark-text--wrap{
    padding-left: 40px;
    padding-right: 40px;
  }
}
@media screen and (max-width: 1023px){
  .hero-dark-text--wrap{
    width: 100%;
    margin: 0;
    padding-top: ${props => props.theme.components_spacing_tablet.medium}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
  }
  h5{
    padding-bottom: ${props => props.theme.components_spacing_tablet.regular}px;
  }
}
@media screen and (max-width: 767px){
  .hero-dark-text--wrap{
    width: 100%;
    margin: 0;
    padding-top: ${props => props.theme.components_spacing_mobile.medium}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    padding-left: 24px;
    padding-right: 24px;
  }
  .hero--video-loop{
    padding-right: 24px;
    padding-left: 24px;
  }
  .text-wrap-cta{
    width: 100%;
  }
  .close-video{
    right: 40px;
  }
  h5{
    padding-bottom: ${props => props.theme.components_spacing_mobile.regular}px;
  }
}

`;

export {
  StyledHomeHeroDark,
};

